import React from "react";
import ImageCardWithDescription from "./ImageCardWithDescription";
import { navigationPropType } from "@template/state/modules/navigation";
import { createIdAriaDescribedBy } from "@template/helpers/navigationAccessibility";

import styles from "./index.css";

const ImageCardsWithDescription = ({ item }) => {
  const { label, items, isFirstColumn, isLastColumn } = item;
  const headerId = createIdAriaDescribedBy(label);

  return (
    <ul className={styles.cardList} aria-labelledby={headerId}>
      {items.slice(0, 8).map((imageItem, index, array) => (
        <ImageCardWithDescription
          item={imageItem}
          key={imageItem.id}
          data-first={isFirstColumn && index === 0 ? true : null}
          data-last={isLastColumn && index === array.length - 1 ? true : null}
        />
      ))}
    </ul>
  );
};

ImageCardsWithDescription.propTypes = {
  item: navigationPropType.isRequired
};

export default ImageCardsWithDescription;
